import { render, staticRenderFns } from "./PhysicianDutyOnPayrollConsolidated.vue?vue&type=template&id=352041ca&scoped=true&"
import script from "./PhysicianDutyOnPayrollConsolidated.vue?vue&type=script&lang=js&"
export * from "./PhysicianDutyOnPayrollConsolidated.vue?vue&type=script&lang=js&"
import style0 from "./PhysicianDutyOnPayrollConsolidated.vue?vue&type=style&index=0&id=352041ca&lang=scss&scoped=true&"
import style1 from "./PhysicianDutyOnPayrollConsolidated.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352041ca",
  null
  
)

export default component.exports